import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { MenuItem } from '@/models/menu';

export const useMenuStore = defineStore('menuItems', () => {
  // State
  const menuItems = ref<MenuItem[]>([]);

  // Getters
  const getMenuItems = computed(() => menuItems.value);
  const hasMenuItems = computed(() => menuItems.value.length > 0);

  // Actions
  const setMenuItems = (items: MenuItem[]) => {
    menuItems.value = items;
  };

  const clearMenuItems = () => {
    menuItems.value = [];
  };

  return {
    // State
    menuItems,

    // Getters
    getMenuItems,
    hasMenuItems,

    // Actions
    setMenuItems,
    clearMenuItems,
  };
});
